import { render, staticRenderFns } from "./DatasComemorativasPage.vue?vue&type=template&id=53611c75&scoped=true"
import script from "./DatasComemorativasPage.vue?vue&type=script&lang=js"
export * from "./DatasComemorativasPage.vue?vue&type=script&lang=js"
import style0 from "./DatasComemorativasPage.vue?vue&type=style&index=0&id=53611c75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53611c75",
  null
  
)

export default component.exports